import { lazy } from "react";
import Loadable from "app/components/Loadable";

const Form1098Setup = Loadable(lazy(() => import("./Form1098Setup")));

const form1098SetupRoute = [{ path: "/form1098-setup", element: <Form1098Setup /> }];
export default form1098SetupRoute;
